import React from 'react';
import { Car, Award, Users } from 'lucide-react';
const TrustBadges = () => {
  return <section className="bg-gray-50 py-16" data-id="element-333">
      <div className="container mx-auto px-4" data-id="element-334">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-335">
          {/* Modern Automatic Vehicles */}
          <div className="flex flex-col items-center text-center" data-id="element-336">
            <div className="bg-blue-100 p-6 rounded-full mb-4" data-id="element-337">
              <Car size={32} className="text-blue-600" data-id="element-338" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-339">
              Modern Automatic Vehicles
            </h3>
            <p className="text-gray-700" data-id="element-340">
              Learn in our dual-controlled, air-conditioned automatic vehicles
              equipped with the latest safety features.
            </p>
          </div>
          {/* Qualified Instructors */}
          <div className="flex flex-col items-center text-center" data-id="element-341">
            <div className="bg-blue-100 p-6 rounded-full mb-4" data-id="element-342">
              <Award size={32} className="text-blue-600" data-id="element-343" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-344">Qualified Instructors</h3>
            <p className="text-gray-700" data-id="element-345">
              All our instructors are DVSA approved with years of experience and
              excellent pass rates.
            </p>
          </div>
          {/* Personalized Lessons */}
          <div className="flex flex-col items-center text-center" data-id="element-346">
            <div className="bg-blue-100 p-6 rounded-full mb-4" data-id="element-347">
              <Users size={32} className="text-blue-600" data-id="element-348" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-349">Personalised Lessons</h3>
            <p className="text-gray-700" data-id="element-350">
              We tailor our teaching methods to suit your learning style and
              help you progress at your own pace.
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default TrustBadges;